<template>
	<button
		type="button"
		class="btn bubble orange small"
		:aria-label="`Remove ${label} filter`"
		@click="emit(`remove`)"
	>
		<span>{{ label }}</span>

		<v-icon slug="xmark" />
	</button>
</template>

<style lang="scss" scoped>
@use '/sass/variables' as *;

.bubble {
	cursor: pointer;

	svg {
		fill: $grey-meta;
	}
}
</style>

<script setup>
import VIcon from './_v-icon.vue';

defineProps({
	label: {
		type: String,
		required: true,
	},
});

const emit = defineEmits([`remove`]);
</script>
